module.exports = __webpack_public_path__ + "static/media/数字化街道社区工作平台.888bcb5a.png";